import {INewBusiness} from "@/views/editor/service/business";
import {Praise} from "@/views/editor/service/challenge/praise";
import {Task} from "@/views/editor/service/challenge/task";

export default {'praise': Praise, 'task': Task} as { [key: string]: INewBusiness }
